import { gridSizeMdLg12 } from '@/shared';
import { CustomSelectTextFieldNoForm, CustomTextFieldNoForm } from '@/shared/components/ui';
import { Box, Button, Card, CardContent, Grid, Typography } from '@mui/material';
import { useState } from 'react';
import { useSearchConsultasPorTipoNap } from '../actions/reports-module.actions';
import { toast } from 'react-toastify';
import TablaConsultasPorTipo from './TablaConsultasPorTipo';

export default function TabConsultasPorTipo() {

    const [filtros] = useState([
        { "id": 1, "name": "Nap" }
    ]);

    const [estados] = useState([
        { "id": 0, "name": "Todos" },
        { "id": 1, "name": "Ocupados" },
        { "id": 2, "name": "Por Liberar" },
        { "id": 3, "name": "Liberados" }
    ]);

    const [formConsulta, setFormConsulta] = useState({
        filtro: 0,
        valor: '',
        estado: 0
    });

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [dataConsultaTipo, setDataConsultaTipo] = useState<any[]>([]);
    const useSearchConsultasPorTipoNapMutation = useSearchConsultasPorTipoNap();
    const onSearch = async () => {

        if (formConsulta.filtro == 0) {
            toast.error('Seleccione un Filtro');
            return false;
        }
        if (formConsulta.valor == '') {
            toast.error('Ingrese un valor a buscar');
            return false;
        }

        setIsLoading(true);
        useSearchConsultasPorTipoNapMutation.mutate(formConsulta as any, {
            onSuccess: (response: any) => {
                const data = response?.data || [];

                const estadosMap: Record<number, string> = {
                    1: "OCUPADO",
                    2: "POR LIBERAR",
                    3: "LIBERADO",
                };

                const estadoSeleccionado = estadosMap[formConsulta.estado];

                const dataFiltrada =
                    formConsulta.estado === 0
                        ? data
                        : data.filter(
                            (item: any) => item.nombre_estado_puerto === estadoSeleccionado
                        );

                setDataConsultaTipo(dataFiltrada);
                setIsLoading(false);
            },
            onError: (error: any) => {
                if (error?.response?.data?.message) {
                    toast.error(error?.response?.data?.message);
                } else {
                    console.error('Error al obtener la informacion:', error);
                    toast.error('Error al obtener la información');
                }
                setIsLoading(false);
                setDataConsultaTipo([]);
            }
        });
    }


    const estadosBase = [
        { name: 'OCUPADO', color: 'green', cantidad: 0 },
        { name: 'POR LIBERAR', color: 'orange', cantidad: 0 },
        { name: 'LIBERADO', color: 'red', cantidad: 0 },
    ];

    const cantidades = dataConsultaTipo.reduce(
        (acc: Record<string, number>, item) => {
            const estado = item.nombre_estado_puerto;

            if (estado) {
                acc[estado] = (acc[estado] || 0) + 1;
            }

            return acc;
        },
        {}
    );

    const listaEstados = [
        ...estadosBase.map((estado) => ({
            ...estado,
            cantidad: cantidades[estado.name] || 0,
        })),
        {
            name: 'TODOS',
            color: 'blue',
            cantidad: dataConsultaTipo.length,
        },
    ];

    return (
        <>
            <Box sx={{ mb: 2 }}>
                <Grid container spacing={1.5}>
                    {listaEstados.map((item, index) => {
                        return (
                            <Grid item xs={6} sm={4} md={1.7} key={index}>
                                <Card
                                    sx={{
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        border: '2px solid transparent',
                                        bgcolor: 'background.paper',
                                        '&:hover': { transform: 'translateY(-2px)', boxShadow: 3, borderColor: item.color },
                                    }}
                                >
                                    <CardContent sx={{ py: 1.5, px: 2, '&:last-child': { pb: 1.5 } }}>
                                        <Typography variant="h4" fontWeight="bold" textAlign="center" color={item.color}>
                                            {item.cantidad}
                                        </Typography>
                                        <Typography variant="caption" textAlign="center" display="block" noWrap fontWeight={500}>
                                            {item.name}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        )
                    })}
                </Grid>
            </Box>
            <Grid item xs={12}>
                <Grid container spacing={1.5}>
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <CustomSelectTextFieldNoForm<any>
                            label="Filtro"
                            defaultValue={formConsulta.filtro || ''}
                            size={gridSizeMdLg12}
                            // options
                            options={filtros || []}
                            menuItemKey="id"
                            valueKey="id"
                            labelKey="name"
                            onChangeValue={(value) => {
                                setFormConsulta({
                                    ...formConsulta,
                                    filtro: parseInt(value)
                                })
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                        <CustomTextFieldNoForm
                            label='Valor a Buscar'
                            defaultValue={formConsulta.valor || ''}
                            size={gridSizeMdLg12}
                            onChangeCustom={(val) => {
                                setFormConsulta({
                                    ...formConsulta,
                                    valor: val.target.value
                                })
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                        <CustomSelectTextFieldNoForm<any>
                            label="Estado"
                            defaultValue={formConsulta.estado || 0}
                            size={gridSizeMdLg12}
                            // options
                            options={estados || []}
                            menuItemKey="id"
                            valueKey="id"
                            labelKey="name"
                            onChangeValue={(value) => {
                                setFormConsulta({
                                    ...formConsulta,
                                    estado: parseInt(value)
                                })
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} lg={2}>
                        <Button variant={'outlined'} color={'info'} size='medium' onClick={() => onSearch()} disabled={isLoading}>Consultar</Button>
                    </Grid>

                    <Grid item lg={12}>
                        <TablaConsultasPorTipo allData={dataConsultaTipo} isLoading={isLoading} onSearch={onSearch} />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}